import React, { memo, useCallback, useEffect } from 'react';
import styles from './HistoryUninstallCard.module.less';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { imgLocalUrl, logNative } from '../../utils/utils';
import defaultImg from '../../static/default.svg';
import { CONTEXT } from '../../config';
import Button from '../../components/Button/Button';
import ApkButton from '../../components/Button/Button';
import { PCStoreJsBridge } from '../../nativeapi';
import { getLocalSoft } from '../../actions/native';

export default memo(({ info, enabled }) => {
  const history = useHistory();
  // 点击打开应用
  const handleOpenSoft = () => {
    if (info.androidType === '1') {
      PCStoreJsBridge.getIsSIMInstalled().then(SIMInstalled => {
        if (SIMInstalled) {
          PCStoreJsBridge.openAndroidSoft({ ...info }).then(isOpen => {
            if (isOpen !== true) {
              // message.info('软件运行失败！');
              // dispatch(getLocalSoft());
            }
          });
        }
        //  else {
        //   // 当不存在模拟器重新获取一次本地列表改变按钮的状态。
        //   dispatch(getLocalSoft());
        // }
      });
    } else {
      PCStoreJsBridge.openSoft(info).then(isOpen => {
        if (isOpen !== true) {
          // message.info('软件运行失败！');
          // dispatch(getLocalSoft());
        }
      });
    }
  };

  const pageJumps = info => {
    if (info.androidType === '1') {
      history.push({
        pathname: `${CONTEXT}/adetail/${info.packageName}/${info.versionCode || 0}/${info.bizInfo ||
          '{}'}`,
      });
    } else {
      history.push({ pathname: `${CONTEXT}/detail/soft/${info.SoftID}/${info.bizInfo || '{}'}` });
    }
  };

  return (
    <div className={styles.card}>
      {info.openBox && (
        <>
          {info.type === 1 && <div className={styles.enabled} onClick={() => enabled(info)} />}
          {info.type === 2 && <div className={styles.unenabled} onClick={() => enabled(info)} />}
          {info.type === 3 && <div className={styles.no_enabled} />}
        </>
      )}
      <div />
      <div className={styles.icon}>
        <img
          src={info.logoFile ?? (info.displayIcon ? imgLocalUrl(info.displayIcon) : defaultImg)}
          alt=""
          onClick={() => pageJumps(info)}
        />
        {info.androidType === '1' && <div className={styles.alogo} />}
      </div>
      <div className={styles.linecard_info}>
        {info.androidType === '1' ? (
          <Link
            to={{
              pathname: `${CONTEXT}/adetail/${info.packageName}/${info.versionCode ||
                0}/${info.bizInfo || '{}'}`,
            }}
          >
            <div className={styles.linecard_info_name} title={info.softName ?? info.displayName}>
              {info.softName ?? info.displayName}
            </div>
          </Link>
        ) : (
          <Link to={`${CONTEXT}/detail/soft/${info.SoftID}/${info.bizInfo || '{}'}`}>
            <div className={styles.linecard_info_name} title={info.softName ?? info.displayName}>
              {info.softName ?? info.displayName}
            </div>
          </Link>
        )}

        <div
          className={styles.linecard_info_desc}
          title={info.introduction || info.whatsNew}
          dangerouslySetInnerHTML={{ __html: info.introduction || info.whatsNew }}
        />
      </div>
      <div className={styles.install}>{info.downloadCount}</div>

      {info.local && <div className={styles.local_install}>本机已安装</div>}
      {!info.local && <div className={styles.local_uninstall}>本机未安装</div>}

      <div className={styles.linecard_btn}>
        {!info.local && (
          <>
            {info.androidType !== '1' ? (
              <Button
                soft={info}
                info={{
                  className: styles.soft_btn,
                  className_busing: styles.soft_btn_b,
                  className_open: styles.soft_button_open,
                }}
              />
            ) : (
              <ApkButton
                soft={info}
                info={{
                  className: styles.soft_btn,
                  className_busing: styles.soft_btn_b,
                  className_open: styles.soft_button_open,
                }}
              />
            )}
          </>
        )}
        {info.local && (
          <>
            {info.androidType === '1' ? (
              <div className={styles.open_btn} onClick={handleOpenSoft}>
                <span>打开</span>
              </div>
            ) : (
              <>
                {info.MainExePath ? (
                  <div className={styles.open_btn} onClick={handleOpenSoft}>
                    打开
                  </div>
                ) : (
                  <div className={styles.open_btn_disable}>打开</div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
});
